import React from 'react';
import { SentimentSnapshot, getSentimentTrendClasses, getSentimentTrendLabel } from './types';

interface SentimentRowProps {
  before?: SentimentSnapshot;
  after?: SentimentSnapshot;
  trend?: string;
  labelBefore?: string;
  labelAfter?: string;
}

/**
 * Displays a before/after sentiment snapshot with a trend indicator.
 */
const SentimentRow: React.FC<SentimentRowProps> = ({
  before,
  after,
  trend,
  labelBefore = 'Before',
  labelAfter = 'After',
}) => {
  const hasSentiment = before || after;
  if (!hasSentiment) return null;

  return (
    <div className="flex flex-wrap items-center gap-3 mt-2 text-sm">
      {before && (
        <div className="flex items-center gap-1">
          <span className="text-gray-500">{labelBefore}:</span>
          <span className="capitalize font-medium text-gray-700">
            {before.emotion}
          </span>
          <span className="text-gray-400 text-xs">
            ({Math.round(before.confidence * 100)}%)
          </span>
        </div>
      )}
      {after && (
        <>
          <span className="text-gray-300">|</span>
          <div className="flex items-center gap-1">
            <span className="text-gray-500">{labelAfter}:</span>
            <span className="capitalize font-medium text-gray-700">
              {after.emotion}
            </span>
            <span className="text-gray-400 text-xs">
              ({Math.round(after.confidence * 100)}%)
            </span>
          </div>
        </>
      )}
      {trend && (
        <>
          <span className="text-gray-300">|</span>
          <span className={`font-semibold text-xs ${getSentimentTrendClasses(trend)}`}>
            {getSentimentTrendLabel(trend)}
          </span>
        </>
      )}
    </div>
  );
};

export default SentimentRow;
